import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor() { }

  /**加密方法 */
  encode(code: string): string{
    return btoa(code);
  }
  /**解密方法 */
  decode(code: string): string{
    return atob(code);
  }
}
